import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { database, ref, get } from '../firebase/config';

const CheckStatus = () => {
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (mobile.length !== 10) {
      setError('Please enter a valid 10-digit mobile number');
      return;
    }
    
    if (!password) {
      setError('Please enter your password');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const applicationRef = ref(database, `applications/${mobile}`);
      const snapshot = await get(applicationRef);
      
      if (snapshot.exists()) {
        const application = snapshot.val();
        
        if (application.password === password) {
          navigate('/status-result', { state: { application } });
        } else {
          setError('Incorrect password. Please try again.');
        }
      } else {
        setError('No application found with this mobile number.');
      }
    } catch (error) {
      console.error('Error checking status:', error);
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-container">
        <div className="auth-card">
          <h2>Check Application Status</h2>
          <p className="auth-subtitle">Enter your mobile number and password to view your loan status</p>
          
          {error && <div className="error-message">{error}</div>}
          
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Mobile Number</label>
              <input
                type="tel"
                value={mobile}
                onChange={(e) => setMobile(e.target.value.replace(/\D/g, '').slice(0, 10))}
                placeholder="Enter 10-digit mobile number"
                required
              />
            </div>
            
            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
              />
            </div>
            
            <button type="submit" className="btn-auth" disabled={loading}>
              {loading ? 'Checking...' : 'Check Status →'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CheckStatus;